import {
  getCurrentOrganizationId as selectOrganizationId,
  getCurrentSpaceId as selectSpaceId
} from '@/components/App/selectors'
import { getAccessToken as selectAccessToken } from '@/components/AuthenticationHandler/selectors'
import { getTenantAPIHost as selectTenantAPiHost } from '@/store/selectors'

import { RootState } from '..'

const memoryCache: {
  accessToken: ReturnType<typeof selectAccessToken> | null
  apiHost: ReturnType<typeof selectTenantAPiHost> | null
  organizationId: ReturnType<typeof selectOrganizationId> | null
  spaceId: ReturnType<typeof selectSpaceId> | null
} = {
  accessToken: null,
  apiHost: null,
  organizationId: null,
  spaceId: null
}

export const getAccessToken = () => memoryCache.accessToken
export const getOrganizationId = () => memoryCache.organizationId
export const getSpaceId = () => memoryCache.spaceId
export const getTenantAPIHost = () => memoryCache.apiHost

/**
 * Redux subscriber that persists portions of Redux store comprising context to an in-memory cache. This allows specific
 * key bits of information to be used outside of Redux specifically in the network request library `fetch`.
 */
export default (store: { getState: () => RootState }) => () => {
  const state = store.getState()

  memoryCache.accessToken = selectAccessToken(state)
  memoryCache.apiHost = selectTenantAPiHost(state)
  memoryCache.organizationId = selectOrganizationId(state)
  memoryCache.spaceId = selectSpaceId(state)
}
